<template>
    <div>{{ dbname }}
        <span v-if="data.lg === 0" class="opencss">{{ openNo }}</span>
        {{ data.detail.ptName }}
        <el-tag v-if="data.detail.statusCode === '10' && data.detail.lawStatus != null" type="success">{{ data.detail.lawStatus }}</el-tag>
        <el-tag v-else-if="data.detail.statusCode === '21' && data.detail.lawStatus != null">{{ data.detail.lawStatus }}</el-tag>
        <el-tag v-else-if="data.detail.lawStatus != null" type="danger">{{ data.detail.lawStatus }}</el-tag>
    </div>
</template>

<script>
export default {
    props: ['data'],
    data() {
        return {
        }
    },
    computed: {
        dbname: function() {
            //console.log(this.data);
            if (this.data.detail.pid === null) {
                return;
            }
            var dbAry = this.data.detail.pid.split('@');
            var db = dbAry[0];
            var name = '';
            if (db === 'FMZL') {
                name = '发明申请';
            } else if (db === 'FMSQ') {
                name = '发明授权';
            } else if (db === 'WGZL') {
                name = '外观授权';
            } else if (db === 'SYXX') {
                name = '实用新型授权';
            }
            return name;
        },
        openNo: function() {
            if (this.data.detail.pid === null) {
                return;
            }
            var dbAry = this.data.detail.pid.split('@');
            return dbAry[1];
        }
    }
}
</script>

<style>
.opencss {
    font-weight: bold;
    color: rgb(7, 54, 125);
    margin-left: 15px;
    margin-right: 15px;
}
</style>